'use client';

import { getEnvironmentConfig } from '../utils/environmentConfig';
import { debug } from '../utils/logger';

// Debug environment variables
debug('[Auth Config] Environment check:', {
    NODE_ENV: process.env.NODE_ENV,
    NEXT_PUBLIC_API_SCOPE_ID: process.env.NEXT_PUBLIC_API_SCOPE_ID,
    isClient: typeof window !== 'undefined'
});

const config = getEnvironmentConfig();

export const msalConfig = {
  auth: {
    clientId: config.clientId,
    authority: `https://login.microsoftonline.com/${config.tenantId}`,
    redirectUri: config.redirectUri,
    postLogoutRedirectUri: config.redirectUri,
    navigateToLoginRequestUrl: true
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: true,
    secureCookies: process.env.NODE_ENV === 'production'
  },
  system: {
    allowNativeBroker: false,
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          debug('[MSAL Logger] Suppressing PII message');
          return;
        }
        debug(`[MSAL ${level}] ${message}`);
      },
      logLevel: process.env.NODE_ENV === 'production' ? "Warning" : "Verbose",
      piiLoggingEnabled: false
    }
  }
};

export const loginRequest = {
  scopes: [`api://${config.apiScopeId}/access_as_user`]
};

if (typeof window !== 'undefined') {
  debug('[Auth Config] Final MSAL config:', msalConfig);
  
  if (!msalConfig.auth.clientId) {
    throw new Error('Missing Azure AD Client ID in configuration');
  }
  if (!msalConfig.auth.authority) {
    throw new Error('Missing Azure AD Authority in configuration');
  }
}